// extracted by mini-css-extract-plugin
export default {"customisationIcons":"InlineIcons-customisationIcons-cQX"};